import { Component, Input, OnInit } from '@angular/core';
import { SessionVariable } from 'src/app/common/enum/session-variable';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';

@Component({
  selector: 'taly-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit {
  @Input() type: any;
  paymentPlanId: any = this.storageService.getItem(SessionVariable.PAYMENT_PLAN_ID);
  constructor(private storageService: LocalStorageService) { }
  ngOnInit(): void {
  }
}
